module.exports = __webpack_public_path__ + "img/icon_map_53_off_001.63248f5e.png";